export default "__VITE_ASSET__CjJXHyxP__"